module.exports = __webpack_public_path__ + "img/academy-badge-certified-advanced.2b760a0.svg";